"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantCapacityUpdateSchema = exports.MerchantCapacityUpdateScalarSchema = exports.MerchantCapacityCreateSchema = exports.MerchantCapacityCreateScalarSchema = exports.MerchantCapacityPrismaUpdateSchema = exports.MerchantCapacityPrismaCreateSchema = exports.MerchantCapacitySchema = exports.MerchantCapacityScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    sunday: zod_1.z.number().gte(-1).default(-1),
    monday: zod_1.z.number().gte(-1).default(-1),
    tuesday: zod_1.z.number().gte(-1).default(-1),
    wednesday: zod_1.z.number().gte(-1).default(-1),
    thursday: zod_1.z.number().gte(-1).default(-1),
    friday: zod_1.z.number().gte(-1).default(-1),
    saturday: zod_1.z.number().gte(-1).default(-1),
}).strict();
const relationSchema = zod_1.z.object({
    merchant: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    merchantId: zod_1.z.string().uuid(),
});
/**
 * `MerchantCapacity` schema excluding foreign keys and relations.
 */
exports.MerchantCapacityScalarSchema = baseSchema;
/**
 * `MerchantCapacity` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.MerchantCapacitySchema = exports.MerchantCapacityScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.MerchantCapacityPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.MerchantCapacityPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    sunday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    monday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    tuesday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    wednesday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    thursday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    friday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())]),
    saturday: zod_1.z.union([zod_1.z.number().gte(-1).default(-1), zod_1.z.record(zod_1.z.unknown())])
}).partial().passthrough();
/**
 * `MerchantCapacity` schema for create operations excluding foreign keys and relations.
 */
exports.MerchantCapacityCreateScalarSchema = baseSchema.partial({
    sunday: true, monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true
});
/**
 * `MerchantCapacity` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantCapacityCreateSchema = exports.MerchantCapacityCreateScalarSchema.merge(fkSchema);
/**
 * `MerchantCapacity` schema for update operations excluding foreign keys and relations.
 */
exports.MerchantCapacityUpdateScalarSchema = baseSchema.partial();
/**
 * `MerchantCapacity` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantCapacityUpdateSchema = exports.MerchantCapacityUpdateScalarSchema.merge(fkSchema.partial());
